<template>
  <CustomPageModuleLayout>
    <template #default="{ id }">
      <CustomPageModule
        :id="id"
        :is-edit-enabled="userStore.isEditEnabled && userStore.isAdmin"
      />
    </template>
  </CustomPageModuleLayout>
</template>

<script setup lang="ts">
import { CustomPageModuleLayout, CustomPageModule } from '@/widgets/custom-page';

const userStore = useUserStore();
</script>
